import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  action: 'listFolders',
  documentId: '',
  versionId: '',
  folderId: '',
  includeSubFolders: false,
  docTypeId: '',
  docTypeIdUpload: '',
  docTypeIdUpdate: '',
  simpleSearch: true,
  contentSearchPhrase: '',
  skip: 0,
  take: 100,
  sortField: 'DocTitle',
  sortDirection: 'Ascending',
  includeDocumentCounts: false,
  title: '',
  destinationFolderId: '',
  tagValues: '',
  fileContent: '',
  fileName: '',
};

export default defaults;
